import axios from 'config/axiosConfig'
import { go, reading_assessment, assessments, report, reports, test_takers, admin_assessments, definitions, categories } from 'keys/apis';


export const createLabelerResponseFetch = (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}labeler_responses/create_response/`, {
        ...values
    })
}

export const getLabelerQuestionFetch = async (params) => {
    return await axios.get(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}labeler_questions/`, {
        params: params
    })
}


export const updateResponseIsReadFetch = (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}labeler_questions/${id}/update_last_response_is_read/`)
}